import Vue from "vue";
import Router from "vue-router";
import Home from "@/pages/Home/Home.vue";
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
import firebase from "firebase";

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.meta.requiresAuth ? to.meta.requiresAuth : false;
  const currentUser = localStorage.uid;

  if (requiresAuth && !currentUser) {
    return next("/");
  } else if (!requiresAuth && currentUser) {
    return next("/dashboard");
  } else return next();
});
Vue.use(Router);

export default router;
